export const FLIPBOOK_URL = "https://heyzine.com/flip-book/b1ca72d59e.html";

export const COVER_IMAGE =
  "https://customer-assets-jt897jd0.emergentagent.net/job_boarding-listings/artifacts/0abaeb6ffd217972_BSD-Cover-2026-1.webp";

export const HERO_BG_IMAGE =
  "https://images.unsplash.com/photo-1721702754494-fdd7189f946c?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85";

export const LOGO_URL = "/bsd-logo.png";

export const hero = {
  title: "BSD Boarding School Directory",
  subtitle: "The Most Comprehensive Compendium of Boarding Schools information across the world.",
  headline: "Discover the Best Boarding School for Your Child",
  tagline: "Elevate Your Child's Potential",
  badges: ["Digital Edition", "Print-on-Demand Edition"],
  cta: "BSD Digital Edition",
};

export const searchSection = {
  title: "Search on Your Finger Tips",
  paragraphs: [
    "Navigating the vast landscape of boarding schools can be daunting, but our meticulously curated compendium makes the process seamless. With in-depth profiles of the top institutions across the globe, you'll have all the information you need to find the perfect fit for your child's academic and personal growth.",
    "Boarding schools offer unparalleled opportunities for intellectual stimulation, character development, and personal discovery. Our compendium showcases the unique advantages of each institution, empowering you to make an informed decision that will unlock your child's full potential.",
    "Confidence in Your Choice – Choosing the right boarding school is a life-changing decision. With our comprehensive resources at your fingertips, you can feel confident that you're selecting the institution that will provide your child with the tools to thrive academically, socially, and personally. Trust us to guide you to educational excellence.",
    "BSD will list more than 2400 boarding schools across the globe. The directory is comprehensive in an easy to refer style making. It is a useful instant reference-based publication for students, parents, Councillors and others seeking information on boarding schools.",
  ],
};

export const promoCards = [
  {
    id: "list-school",
    title: "List Your Boarding School",
    body:
      "BSD captures complex information of Boarding Schools Education in the most inclusive manner. We deliver very high readership across 3 media platforms – Print, Digital and Mobile. Schools are featured in the listing format focusing on informed decision making by the students. We extensively promote across students, parents and councilors. Get your School listed in BSD today.",
    cta: "View Listing Details!",
    to: "/list-your-school/listing-options",
  },
  {
    id: "print-edition",
    title: "Order Print Edition",
    body:
      "Boarding School Directory is an authentic, exhaustive and handy publication which gives latest information on school courses, facilities, academics, fees and more. The publication lists largest number of schools with residential facilities. Latest print edition contains more than 2400 schools in more than 190 cities. You can order Printed & Digital Edition.",
    cta: "Order Print Edition",
    to: "/list-your-school/brochure-media-kit",
  },
  {
    id: "digital-edition",
    title: "Open Digital Edition",
    body:
      "Experience the latest mode of viewing & searching the Boarding schools on your screen. Easy to navigate, the Digital Edition of Boarding School Directory enables you to view or flip all institutes at one place. Easy to browse with details including the subjects, streams, residential facilities, fees etc. BSD Digital edition opens on Laptop/Desktop, Tabs, and Mobile.",
    cta: "View the latest Digital Edition",
    to: "/digital-edition",
  },
];

export const multiDeviceSection = {
  paragraphs: [
    "BSD Boarding School Directory is your perfect reference while seeking information on finest boarding schools across the globe including academic curriculum & achievements, teaching faculty, boarding facilities, extracurricular, sports, ethos and heritage and more.",
    "BSD is available on multiple devices – web, iPad and mobile. Access full course information, with full guidance to admit a boarding school, on your fingertips.",
    "Schools are listed in a systematic manner according to Country-wise giving full information including courses, facilities, fees, ranking, etc.",
    "BSD is the only consolidated source of information in Digital & Print-on-demand medium on Boarding Schools. Featuring all over the world, it opens the information source for students to compare all the merits including the rankings, academics, cost, facilities etc.",
  ],
  pills: ["Schools Listing", "Print-on-Demand", "Any device, anytime, anywhere"],
};

export const listingOpportunity = {
  title: "Listing Opportunity for Boarding Schools",
  intro:
    "A comprehensive publication, BSD Boarding School Directory serves as a centralized repository of information, providing parents with detailed profiles of boarding schools from around the globe. It consolidates essential details about each school, including academic offerings, extracurricular activities, campus facilities, and admission requirements, all in one convenient location.",
  features: [
    {
      title: "Centralized Information Source",
      body:
        "A comprehensive directory serves as a centralized repository of information, providing parents with detailed profiles of boarding schools from around the globe. It consolidates essential details about each school, including academic offerings, extracurricular activities, campus facilities, and admission requirements, all in one convenient location. This helps streamline the search process, making it easier for parents to compare and contrast different schools based on their specific needs and preferences.",
    },
    {
      title: "Diverse Educational Options",
      body:
        "Boarding schools vary widely in their educational approaches, extracurricular offerings, and campus environments. A comprehensive directory highlights this diversity, showcasing schools that specialize in various academic disciplines, arts, sports, and other areas. This variety helps parents find the perfect fit for their child, whether they are looking for a school with a strong STEM focus, a vibrant arts program, or a commitment to holistic development.",
    },
    {
      title: "Informed Decision-Making",
      body:
        "Choosing the right boarding school is a critical decision that can significantly impact a child's future. A well-curated directory offers unbiased and accurate information, enabling parents to make informed choices. It provides insights into each school's educational philosophy, culture, and community, allowing parents to select an institution that aligns with their child's personality, interests, and educational goals.",
    },
    {
      title: "International Education",
      body:
        "For families considering international education, navigating the complexities of different education systems, languages, and cultural contexts can be challenging. A global boarding school directory provides valuable guidance and information on schools in different countries, helping parents understand the unique advantages and requirements of each. This accessibility opens up a world of educational opportunities, enabling students to experience different cultures and educational approaches.",
    },
    {
      title: "Trustworthy and Verified Information",
      body:
        "BSD Boarding School Directory serves as a trusted source of verified information, curated by experts in the field of education. Parents can rely on the accuracy and credibility of the data, confident that the schools featured have been thoroughly reviewed and meet high standards of quality and integrity. This trust is particularly important when considering boarding schools, as parents must feel assured of their child's safety and well-being.",
    },
  ],
};

export const FOOTER_TEXT =
  "BSD Boarding School Directory, is the single largest information on boarding / residential schools globally. BSD is released in Print, Digital and web formats. A compendium of schools offering academic learning to Primary, Junior, Secondary school education, with world class boarding facilities.";

export const CONTACT = {
  company: "Perfect Multimedia Global Limited",
  lines: ["51 Bracken Road, Sandyford", "Dublin D18 CV48, Ireland"],
};

export const sectionImages = {
  search: "https://images.unsplash.com/photo-1721702754494-fdd7189f946c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  listing: "https://images.pexels.com/photos/32211739/pexels-photo-32211739.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  print: "https://images.unsplash.com/photo-1616271735769-2c8e8bbae5f8?crop=entropy&cs=srgb&fm=jpg&w=940&q=85",
  digital: "https://images.pexels.com/photos/159775/library-la-trobe-study-students-159775.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  opportunity: "https://images.pexels.com/photos/28176028/pexels-photo-28176028.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
